import { useQuery, useMutation } from '@apollo/react-hooks';
import React from 'react';
import styles from './ProfilePageContent.module.css';
import EditFieldPopup from '../ProfilePageEditPopup/ProfilePageEditPopup';
import {
  GET_PROFILE_RECORDS,
  GET_PROFILE_ACCOUNT_MANAGEMENT_RECORDS,
  UPDATE_PROFILE_DATA
} from '../../../../graphql/Profile';
import Loader from '../../../../base/components/Loader/Loader';
import amEdit from '../../../../assets/img/accountmanagement/am-edit.svg';
import RecordAction from '../RecordAction/RecordAction';

export default () => {
  const {
    data: { getProfileData } = {},
    loading: profileLoading,
    error: profileError,
    refetch: refetchProfile
  } = useQuery(GET_PROFILE_RECORDS, {
    fetchPolicy: 'network-only'
  });

  const {
    data: { getAccountManagementData } = {},
    loading: accountLoading,
    error: accountError
  } = useQuery(GET_PROFILE_ACCOUNT_MANAGEMENT_RECORDS, {
    fetchPolicy: 'network-only'
  });
  const [activeField, setActiveField] = React.useState(null);
  const [updateProfile, { loading: updateLoading }] = useMutation(
    UPDATE_PROFILE_DATA
  );

  if (profileLoading || accountLoading) return <Loader />;
  if (profileError) return <p>Error: {profileError.message}</p>;
  if (accountError) return <p>Error: {accountError.message}</p>;

  return (
    <div className={styles.profileContainer}>
      <div className={styles.profileItem}>
        <span className={styles.profileItemLabel}>First Name:</span>
        <span className={styles.profileItemValue}>
          {getProfileData.firstname}
        </span>
        <RecordAction
          label="Edit"
          icon={amEdit}
          onClick={() => setActiveField('firstname')}
        />
      </div>

      <div className={styles.profileItem}>
        <span className={styles.profileItemLabel}>Last Name:</span>
        <span className={styles.profileItemValue}>
          {getProfileData.lastname}
        </span>
        <RecordAction
          label="Edit"
          icon={amEdit}
          onClick={() => setActiveField('lastname')}
        />
      </div>

      <div className={styles.profileItem}>
        <span className={styles.profileItemLabel}>Telephone:</span>
        <span className={styles.profileItemValue}>
          {getProfileData.telephone}
        </span>
        <RecordAction
          label="Edit"
          icon={amEdit}
          onClick={() => setActiveField('telephone')}
        />
      </div>

      <div className={styles.profileItem}>
        <span className={styles.profileItemLabel}>Company:</span>
        <span className={styles.profileItemValue}>
          {getProfileData.company}
        </span>
        <RecordAction
          label="Edit"
          icon={amEdit}
          onClick={() => setActiveField('company')}
        />
      </div>

      <div className={styles.profileItem}>
        <span className={styles.profileItemLabel}>Email:</span>
        <span className={styles.profileItemValue}>{getProfileData.email}</span>
      </div>

      <div className={styles.profileItem}>
        <span className={styles.profileItemLabel}>Joined:</span>
        <span className={`${styles.profileItemValue} ${styles.date}`}>
          {getProfileData.createdAt
            ? new Date(getProfileData.createdAt).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              })
            : '—'}
        </span>
      </div>

      <div className={styles.profileItem}>
        <span className={styles.profileItemLabel}>How did you know Buffl:</span>
        <span className={styles.profileItemValue}>
          {getProfileData.howDidYouLearnAboutBuffl}
        </span>
      </div>
      <div className={styles.profileItem}>
        <span className={styles.profileItemLabel}>Account management:</span>

        <div className={styles.profileItemValue}>
          <ul className={styles.accountList}>
            {getAccountManagementData.map(item => (
              <li key={item._id} className={styles.accountListItem}>
                {item.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
      {activeField && (
        <EditFieldPopup
          title="Edit profile"
          fieldName={activeField}
          profileData={getProfileData}
          submitLoading={updateLoading}
          onClose={() => setActiveField(null)}
          refetchProfile={refetchProfile}
          onSubmit={input => updateProfile({ variables: { input } })}
        />
      )}
    </div>
  );
};
